import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import OnboardingWizardInnerPermissionsQuery from '@jira/admin-pages__onboarding-hub-wizard/src/__generated__/OnboardingWizardInnerPermissionsQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const onboardingHubWizardWithDelegatedAdminEntryPoint = createEntryPoint({
	// Using `JSResourceForInteraction` to avoid SSR
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-onboarding-hub-wizard-with-delegated-admin" */ './OnboardingHubWizardWithDelegatedAdminEntryPointRoot.tsx'
		).then((module) => module.OnboardingHubWizardWithDelegatedAdminEntryPointRoot),
	),
	getPreloadProps: ({
		context,
		tenantContext: { cloudId, isAdmin, appEditions },
	}: EntryPointRouteParams) => ({
		extraProps: {
			id: context.match.params?.id || '',
		},
		queries: {
			permissionsQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: OnboardingWizardInnerPermissionsQuery,
				variables: {
					cloudId,
					// We can skip the permission check when:
					// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
					// 2. Upsell is enabled (because upsell is only available to admins)
					skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION',
				},
			},
		},
	}),
});
